import { atom, useRecoilValue, useSetRecoilState } from 'recoil';

export const configuratorZoomed = atom<boolean>({
    key: 'configuratorZoomed',
    default: false,
});

export const useConfiguratorZoomedValue = () => useRecoilValue(configuratorZoomed);
export const useConfiguratorZoomedSetState = () => useSetRecoilState(configuratorZoomed);
